// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"StatsTableView-module__tableContainer___3nupT","customTable":"StatsTableView-module__customTable___2vU_l"};